import { isNextDepositBonus, isWelcomeDepositBonus } from '@/guards/bonusesGuards';
import type { FreeRoundsBonus, Player, DepositBonusesWithLimits, DepositBonusesWithLimitsRaw, DepositBonusesNoLimitsRaw, DepositBonusesNoLimits, FreeRoundsBonusRaw } from '@/types';
import { defaultCurrency } from '@/utils/variables';
export const bonusAdapter = {
    mapDepositBonusLimits(item: DepositBonusesWithLimitsRaw, player: Player, newBonusId?: number | null): DepositBonusesWithLimits {
        const currentCurrency: string = (player?.currency as keyof typeof item.currency_limits) || defaultCurrency;
        const haveLimits = isNextDepositBonus(item) || isWelcomeDepositBonus(item);
        const currentCurrencyLimits = haveLimits ? item.currency_limits[currentCurrency] : null;
        const formattedBonus = {
            ...item,
            loadingItem: false,
            isNewBonus: newBonusId === item.id,
            flip: false
        };
        const minDep = currentCurrencyLimits ? currentCurrencyLimits.min_dep : 0;
        const maxDep = currentCurrencyLimits ? currentCurrencyLimits.max_dep : 0;
        const startDateTime = item.start_datetime ? `${new Date(item.start_datetime).toLocaleDateString()} ${new Date(item.start_datetime).toLocaleTimeString()}` : null;
        return {
            ...formattedBonus,
            start_datetime: startDateTime,
            min_dep: minDep,
            max_dep: maxDep
        };
    },
    mapDepositBonusNoLimits(item: DepositBonusesNoLimitsRaw, newBonusId?: number | null): DepositBonusesNoLimits {
        return {
            ...item,
            loadingItem: false,
            isNewBonus: newBonusId === item.id,
            flip: false
        };
    },
    mapFreeRoundsBonus(item: FreeRoundsBonusRaw, newBonusId?: number | null): FreeRoundsBonus {
        return {
            ...item,
            loadingItem: false,
            isNewBonus: newBonusId === item.id,
            flip: false
        };
    }
};
